"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var initialFieldState = {
  focus: false,
  pending: false,
  pristine: true,
  submitted: false,
  submitFailed: false,
  retouched: false,
  touched: false,
  valid: true,
  validating: false,
  validated: false,
  validity: {},
  errors: {},
  intents: []
};

exports.default = initialFieldState;


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/constants/initial-field-state.js
// module id = 57
// module chunks = 0